module.exports = __webpack_public_path__ + "static/img/12.9923442.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/eng/12.png
// module id = CL4R
// module chunks = 0